const DeviceAppStatusEnum= {
    PLAYING: "Running",
    STOPPED: "Stopped",
    ERROR: "Error"
}

export default DeviceAppStatusEnum;